import { z } from "zod";

// Schema for TradesPurple onboarding
export const tradespurpleOnboardingSchema = z.object({
  username: z
    .string()
    .min(3, "Username must be at least 3 characters")
    .max(20, "Username must be less than 20 characters")
    .regex(
      /^[a-zA-Z0-9_-]+$/,
      "Username can only contain letters, numbers, underscores, and hyphens"
    ),
  postcode: z
    .string()
    .min(2, "Postcode must be at least 2 characters")
    .max(4, "Postcode must be 2-4 characters (first part only)")
    .regex(
      /^[A-Z]{1,2}[0-9]{1,2}$/i,
      "Please enter a valid UK postcode area (e.g. HP22)"
    ),
});

export type TradesPurpleOnboardingValues = z.infer<typeof tradespurpleOnboardingSchema>;